{
  "GENERAL": {
    "SHOWING_RESULTS": "Mostrando {firstIndex}-{lastIndex} di {totalCount} elementi",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Cerca",
      "EMPTY_STATE": "Nessun risultato trovato"
    },
    "CLOSE": "Chiudi",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "Questa funzione è in beta e può subire variazioni mentre la miglioriamo.",
    "ACCEPT": "Accetta",
    "DISCARD": "Annulla",
    "PREFERRED": "Preferito"
  },
  "CHOICE_TOGGLE": {
    "YES": "Sì",
    "NO": "No"
  }
}
